<template>
  <div>
  <div class="container seg-content general user">
    <section class="home-list">
      <div class="hl-wid ww4 watch-filter">
        <h4>Total watch stats</h4>
        <form class="user-form filter">
          <div class="filter-field">
            <label>Date from:</label>
            <datepicker v-model="dateStart" v-on:input="loadWatchStats" />
          </div>
          <div class="filter-field">
            <label>Date to:</label>
            <datepicker v-model="dateEnd" v-on:input="loadWatchStats" />
          </div>
          <div class="filter-field">
            <label>User</label>
            <keyval-select :options="users" v-model="userId" v-on:input="loadWatchStats" />
          </div>
          <div class="filter-field">
            <label>Video</label>
            <keyval-select :options="videos" v-model="videoId" v-on:input="loadWatchStats" />
          </div>
        </form>
      </div>
      <div class="hl-wid ww4 watch-totals">
        <h4>Per date</h4>
        <ul>
          <li v-for="date in dates">
            <span class="date">{{ date.label }}</span>
            <span class="count">{{ date.count }} views</span>
            <span class="duration">{{ formatDuration(date.duration) }}</span>
          </li>
        </ul>
      </div>
      <div class="hl-wid ww4 watch-totals" v-if="!(this.userId*1)">
        <h4>Per user</h4>
        <ul>
          <li v-for="date in perUser">
            <span class="user">{{ date.label }}</span>
            <span class="count">{{ date.count }} views</span>
            <span class="duration">{{ formatDuration(date.duration) }}</span>
          </li>
        </ul>
      </div>
      <div class="hl-wid ww4 watch-totals" v-if="!(this.videoId*1)">
        <h4>Per video</h4>
        <ul>
          <li v-for="date in perVideo">
            <span class="video">{{ date.label }}</span>
            <span class="count">{{ date.count }} views</span>
            <span class="duration">{{ formatDuration(date.duration) }}</span>
          </li>
        </ul>
      </div>
    </section>
  
    
    

    
  </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data: ()=>({
    menuOpen: false,
    dateStart: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dateEnd: moment().subtract(0, "days").format("YYYY-MM-DD"),
    userId: 0,
    videoId: 0,
    mode: 'date',
    items: [],
    users: {},
    videos: {},
  }),
  computed: {
    dates() {
      var result=[];
      var start=moment(this.dateStart);
      var end=moment(this.dateEnd);
      while(start.isSameOrBefore(end)) {
        var today=start.format("YYYY-MM-DD");
        var watchCount=0, watchDuration=0;
        
        for(var item of this.items)
          if ((item.started || "").substring(0, 10)==today) {
            watchCount++;
            watchDuration+=item.watched*1;
          }
        
        result.push({date: start.format("YYYY-MM-DD"),
                     label: start.format("Do MMM YYYY"),
                     count: watchCount,
                     duration: watchDuration});
        start.add(1, "day");
      }
      result=result.filter((a)=>a.duration);
      return result;
    },
    perUser() {
      var result=[];
      for(var user in this.users) {
        var watchCount=0, watchDuration=0;
        
        for(var item of this.items)
          if (item.user==user) {
            watchCount++;
            watchDuration+=item.watched*1;
          }
        
        result.push({id: user,
                     label: this.users[user],
                     count: watchCount,
                     duration: watchDuration});
      }
      result=result.filter((a)=>a.duration).sort((a,b)=>{
        if (a.count>b.count) return -1;
        if (a.count<b.count) return 1;
        return 0;
      });
      return result;
    },
    perVideo() {
      var result=[];
      for(var video in this.videos) {
        var watchCount=0, watchDuration=0;
        
        for(var item of this.items)
          if (item.video==video) {
            watchCount++;
            watchDuration+=item.watched*1;
          }
        
        result.push({id: video,
                     label: this.videos[video],
                     count: watchCount,
                     duration: watchDuration});
      }
      result=result.filter((a)=>a.duration).sort((a,b)=>{
        if (a.count>b.count) return -1;
        if (a.count<b.count) return 1;
        return 0;
      });
      return result;
    },
  },
  methods: {
    formatDuration(duration) {
      var result=[];
      var hours=Math.floor(duration/3600)%60;
      if (hours)
        result.push(hours+"h");
      var minutes=Math.floor(duration/60)%60;
      if (minutes)
        result.push(minutes+"m");
      var seconds=Math.floor(duration)%60;
      result.push(seconds+"s");
      return result.join(" ");
    },
    toggleMenu() {
      this.menuOpen=!this.menuOpen;
      if (!this.menuOpen)
        this.$refs.mobileMenu.menuSubOpen=null;
    },
    action($event) {
      var actionName="action"+($event.name[0].toUpperCase())+($event.name.substring(1));
      
      this[actionName] && this[actionName]($event);
    },
    async loadVideos() {
      var result={};
      var videos=(await api.list("Video")).items;
      for(var video of videos)
        result[video.id]=video.title;
      result[0]="(all)";
      this.videos=result;
    },
    async loadUsers() {
      var result={};
      var users=(await api.list("User")).items;
      for(var user of users)
        result[user.id]=user.firstname+" "+user.lastname;
      result[0]="(all)";
      this.users=result;
    },
    async loadWatchStats() {
      this.items=[];
      var where={
        dateStart: [">=", this.dateStart+" 00:00:00", "started"],
        dateEnd: ["<=", this.dateEnd+" 23:59:59", "started"],
      };
      if (this.userId*1)
        where.user=this.userId;
      if (this.videoId*1)
        where.video=this.videoId;
      
      this.items=(await api.list("WatchLog", where)).items;
    },
  },
  mounted() {
    this.loadUsers();
    this.loadVideos();
    this.loadWatchStats();
  },
}
</script>
